import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import AuthService from "../services/AuthService";

export default class ActivityLocation extends Component {
    static displayName = ActivityLocation.name;

    constructor(props) {
        super(props);
        
        this.state = {
            suggestions: [],
            addressTypes: {defaultAddressType:null, addressTypes:[{description: "", value: null}]},
            authenticatedUser: null
        };

        this.lastAddressSearch = null;
    }

    getUser = async () => {
        return await this.authService.getAuthenticatedUser(true);
    }

    async componentDidMount() {
        console.log('ActivityLocation mounted', this.props);
        this.authService = await AuthService.getInstance();
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', `Bearer ${(await this.getUser()).access_token}`);

        window.fetch('api/Address/AddressTypes', {
            method: 'GET',
            headers: headers
            })
            .then(response => {
                if (response.status === 200)
                    return response.json();
                else 
                {
                    console.error("Error getting address types", response);
                    alert("Error getting address types");
                    return [];
                }
            })
            .then(data => {
                this.setState({
                    addressTypes: data
                });
                // have to retriev preferences after address types has completed otherwise error
                window.fetch('api/UserPreferences/MyPreferences', {
                    method: 'GET',
                    headers: headers
                    })
                    .then(response => {
                        console.log(response);
                        if (response.status === 200)
                            return response.json().catch(function(reason) {
                                alert(reason);
                            });
                        else {
                            this.setState({
                                loaded: true
                            })
                            return Promise.reject("Not found");
                        }
                    })
                    .then(data => {
                        this.setState({loaded: true});
                        // only override with preferences if not already set
                        if(this.props.activityLocation.Address.Address1 === "" && data.address){
                            if(data.address.Address.Address1 == null)
                                data.address.Address.Address1 = this.props.activityLocation.Address.Address1;
                            if(data.address.Address.Address2 == null)
                                data.address.Address.Address2 = this.props.activityLocation.Address.Address2;                            
                            // only override Name with preferences if it's blank
                            if(this.props.activityLocation.Address.Name) 
                                data.address.Address.Name = this.props.activityLocation.Address.Name;
                            if(data.address.Address.Name == null)
                                data.address.Address.Name = this.props.activityLocation.Address.Name;
                            if(data.address.Address.suburb.name == null)
                                data.address.Address.suburb.name = this.props.activityLocation.Address.suburb.name;
                            if(data.address.Address.suburb.pcode == null)
                                data.address.Address.suburb.pcode = this.props.activityLocation.Address.suburb.pcode;
                            if(data.address.Address.suburb.depot.name == null)
                                data.address.Address.suburb.depot.name = this.props.activityLocation.Address.suburb.depot.name;
                            if(data.address.Contact.Name == null)
                                data.address.Contact.Name = this.props.activityLocation.Contact.Name;
                            if(data.address.Contact.Mobile == null)
                                data.address.Contact.Mobile = this.props.activityLocation.Contact.Mobile;
                            if(data.address.Contact.Phone == null)
                                data.address.Contact.Phone = this.props.activityLocation.Contact.Phone;
                            if(data.address.Contact.Email == null)
                                data.address.Contact.Email = this.props.activityLocation.Contact.Email;
                            if(data.address.Instruction == null)
                                data.address.Instruction = this.props.activityLocation.Instruction;
                            //console.log('data.address, activitylocation', data.address, this.props.activityLocation);
                            // set default new delivery address to my current default
                            this.props.onActivityLocationChanged({...this.props.activityLocation, ...data.address});
                        }                         
                    })
                    .catch(error => {
                        console.log('Preferences not found for activity location', error);
                    });
            })
            .catch(error => {
                alert('Error getting address types', error);
        });
    }

    selectAddress = async (selectedAddr) => {
        this.setState({suggestions: []});
        this.props.onActivityLocationChanged({...this.props.activityLocation, Address: {...this.props.activityLocation.Address, Address1: selectedAddr.Addr, Id: selectedAddr.Id}});
        var detail = await this.getAddressSuggestionDetails(selectedAddr);
        console.log('selected detail', detail);
        if(!detail || !detail.suburb){            
            alert('Sorry something is wrong with that address, please try another one or contact us');
            this.props.onActivityLocationChanged({...this.props.activityLocation, Address: {...this.props.activityLocation.Address, Address1: "", Id: 0}});
        }
        else{
            console.log("Setting to detail", detail); 
            var address_type = this.state.addressTypes.addressTypes.find(o=>{return o.value === detail.address_type.value});
            this.props.onActivityLocationChanged({...this.props.activityLocation, 
                Address: {...detail, 
                    address_type: address_type || this.props.activityLocation.Address.address_type, 
                    Name: detail.Name || this.props.activityLocation.Address.Name,
                    Address2: detail.Address2 || this.props.activityLocation.Address.Address2,
                    Instruction: detail.Instruction || this.props.activityLocation.Instruction}}); 
        }
    }

    getAddressSuggestions = async (query, signal) => {
        //console.log('query:' + query);

        return this.authService.getUser()
            .then(user => {

                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `Bearer ${user.access_token}`);

                return window.fetch(`api/Address/Search?query=${query}`,
                    {
                        method: 'GET',
                        headers: headers,
                        signal, signal
                    })
                    .then(response => {
                        if (response.status === 200) {
                            return response.json();
                        }
                        return Promise.reject();
                    })
                    .catch(error => {
                        console.log(error);
                    });

            });
    }

    getAddressSuggestionDetails = async (suggestion) => {
        var user = await this.authService.getUser();

        if (user) {

            var results = null;

            const headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', `Bearer ${user.access_token}`);

            await window.fetch(`api/Address/Details`,
                {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(suggestion)
                })
                .then(response => {
                    if (response.status === 200) {
                        return response.json();
                    }
                    return Promise.reject();
                }).then(data => {
                    results = data;
                })
                .catch(error => {
                    console.log(error);
                });
            return results;
        }

        return null;
    }

    setAddressType = (newAddressType) => {        
        var newActivityLocation = {...this.props.activityLocation, 
            Address: {...this.props.activityLocation.Address, address_type: newAddressType || this.props.activityLocation.Address.address_type}};
        console.log('newAddressType', newAddressType);
        console.log('newActivityLocation', newActivityLocation);
        this.props.onActivityLocationChanged(newActivityLocation); 
    }
        
    searchAddresses = async (e) => {      
        var newVal = !e.target.value || e.target.value == null ? "" : (e.target.value || "");
        if(newVal.length <= 4){            
            this.setState({suggestions: []});
        }

        this.props.onActivityLocationChanged({...this.props.activityLocation, 
            Address: {
                ...this.props.activityLocation.Address, 
                Id: 0, 
                Address1: newVal, Addr: newVal, 
                suburb: { name: "", pcode: "", depot: { code:"", name:""} }
            }
        });        
        if(newVal.length > 4) {
            if(this.lastAddressSearch)
                clearTimeout(this.lastAddressSearch);

            let search = this.getAddressSuggestions;
            this.lastAddressSearch = setTimeout(async () => {
                // now get the suggestions        
                var suggestions = await search(newVal);
                if(suggestions && suggestions.length) {
                    this.setState({suggestions: suggestions});
                }
            }, 200);
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="header">New Delivery Address</div>
                <fieldset>
                    <div className="form-group">
                        <label>Business / Name</label>
                        <input type="text" className="form-control" value={this.props.activityLocation.Address.Name || ""} onChange={e => this.props.onActivityLocationChanged({ ...this.props.activityLocation, Address: { ...this.props.activityLocation.Address, Name: e.target.value } } )} />
                    </div>
                    <div className="form-group">
                        <label>Address Type</label>
                        <div className="${styles.addressTypeP}`">
                            {<DropDownList value={this.props.activityLocation.Address.address_type} onChange={e => this.setAddressType(e.target.value)}
                                data={this.state.addressTypes.addressTypes} textField="description" dataItemKey="value" valueMap={value => value && value.value}
                                style={{ width: '100%' }}
                            />}
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Address</label>
                        <input type="text" className="form-control" value={this.props.activityLocation.Address.Address1} onChange={this.searchAddresses} />
                        {(this.state.suggestions && this.state.suggestions.length > 0) &&
                            <div className="autocomplete-dropdown dropdown-menu">
                                {this.state.suggestions.map((sug) => <div className="dropdown-item" key={sug.Id} onClick={() => { this.selectAddress(sug) }}>{sug.Addr}</div>)}
                            </div>}
                    </div>
                    <div className="form-group">
                        <label>Building/Unit/Level</label>
                        <input type="text" className="form-control" value={this.props.activityLocation.Address.Address2} onChange={e => this.props.onActivityLocationChanged({ ...this.props.activityLocation, Address: { ...this.props.activityLocation.Address, Address2: e.target.value } })} />
                    </div>
                    <div className="form-group">
                        <label>Suburb</label>
                        <input readOnly type="text" className="form-control" value={this.props.activityLocation.Address.suburb.name} />
                    </div>
                    <div className="form-group">
                        <label>Depot</label>
                        <input readOnly type="text" className="form-control" value={this.props.activityLocation.Address.suburb.depot.name} />
                    </div>
                    <div className="form-group">
                        <label>Postcode</label>
                        <input readOnly type="text" className="form-control" value={this.props.activityLocation.Address.suburb.pcode} />
                    </div>
                    <div className="form-group">
                        <label>Instruction</label>
                        <input type="text" className="form-control" value={this.props.activityLocation.Instruction} onChange={e => this.props.onActivityLocationChanged({ ...this.props.activityLocation, Instruction: e.target.value })} />
                    </div>                    
                </fieldset>
            </React.Fragment>
        );
    }
}
